import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col
} from "reactstrap";

import BasicModal from '../../../../components/Modals/BasicModal'
import SelectApp from './SelectApp';
import { getApps } from "../../../../network/ApiAxios";
import {titleCase} from '../../../../utils/views/pages/Dynamics'
import  secureLocalStorage  from  "react-secure-storage";

const ManagementInformation = (props) => {
    const plan = props.plan
    const formDisabled = props.formDisabled
    const setPlan = props.setPlan
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const [showSelectInst, setShowSelectInst] = useState(false)
    const [selectOptions, setSelectOptions] = useState([])
    const validations = props.validations
    const user = JSON.parse(secureLocalStorage.getItem("user"));

    useEffect(() => {
        const runAsync = async () => {

            let params = { userId: user._id }

            const response = await getApps(params);
            const { data } = response;

            if (data.success && data.apps?.length>0) {
                setSelectOptions(data.apps)
                setShowSelectInst(true)
            }
        }

        runAsync();

    }, [showSelectInst])

    let validateField = (e) => {
        //console.log(!e.target.value.trim() && e.target.required)
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {

        plan[e.target.name] = e.target.value
        setPlan(plan)

    }

    return (
        <>
            {/* Address */}
            <h6 className="heading-small text-muted mb-4">
                Management information
            </h6>
            <div className="pl-lg-4">
            {function () {
                    if (!showSelectInst)
                        return;

                    return (
                        <Row>
                            <Col lg="6">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-app"
                                    >
                                        App
                                    </label>

                                    <SelectApp
                                        appId={plan?.app?._id}
                                        formDisabled={formDisabled}
                                        setPlan={setPlan}
                                        selectOptions={selectOptions}
                                        plan={plan} />

                                </FormGroup>
                            </Col>
                        </Row>

                    )

                }()

                }
                
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-detail"
                            >
                                Details
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={plan?.detail}
                                id="input-detail"
                                name="detail"
                                placeholder="Plan Details"
                                type="textarea"
                                rows="5"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={false}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                
            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />

        </>
    )
}

export default ManagementInformation;